import { formatClock } from '../chat/format';

export const WINDOW_CLOSED_FACT = 'Encerrada — o cliente precisa escrever de novo';

const MS_PER_DAY = 86_400_000;
const pad2 = (n: number): string => String(n).padStart(2, '0');

/** Número do dia no calendário LOCAL (contar dias pelas partes locais evita errar perto da meia-noite). */
function localDayNumber(date: Date): number {
  return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / MS_PER_DAY);
}

/**
 * Hora em que a janela fecha, no fuso de quem olha e no formato das horas do app ("15:20"). Se o
 * prazo cai em outro dia, o dia vem junto ("amanhã às 15:20", "27/10 às 15:20"): sem isso, às
 * 15:30 de hoje "até 15:20" pareceria um prazo que já passou.
 */
export function formatWindowExpiry(expiresAt: number, now: number): string {
  const date = new Date(expiresAt);
  const clock = formatClock(date.toISOString());
  const days = localDayNumber(date) - localDayNumber(new Date(now));
  if (days <= 0) return clock;
  if (days === 1) return `amanhã às ${clock}`;
  return `${pad2(date.getDate())}/${pad2(date.getMonth() + 1)} às ${clock}`;
}
